
import { useEffect } from 'react';

/**
 * Hook for safely using async effects with proper cleanup
 * @param asyncEffect The async effect function
 * @param dependencies Dependencies array for the effect
 */
export function useAsyncEffect(
  asyncEffect: () => Promise<void | (() => void)>,
  dependencies: React.DependencyList = []
): void {
  useEffect(() => {
    let isMounted = true;
    let cleanup: void | (() => void);

    const execute = async () => {
      try {
        cleanup = await asyncEffect();
      } catch (error) {
        if (isMounted) {
          console.error('Error in async effect:', error);
        }
      }
    };

    execute();

    return () => {
      isMounted = false;
      if (typeof cleanup === 'function') {
        cleanup();
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
